// extracted by mini-css-extract-plugin
export var infoRow = "_us-2";
export var labelContainer = "_us-0";
export var rightInfo = "_us-1";